import { render, staticRenderFns } from "./TestAPIForm.vue?vue&type=template&id=10687309"
import script from "./TestAPIForm.vue?vue&type=script&lang=js"
export * from "./TestAPIForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports